import React from 'react';
import { Dropdown } from 'antd';
import {
    RollbackOutlined,
    CopyOutlined,
    DownloadOutlined,
    InfoCircleOutlined,
    DownOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const MessageBubbleActions = ({
    message,
    hasMedia,
    canReplyToThis,
    onAction,
    children,
    isHovered,
    contextMenuOpen,
    setContextMenuOpen,
    isMobile,
    isViewOnly = false
}) => {
    const { t } = useTranslation();

    if (isViewOnly) {
        return children;
    }

    const menuItems = [{
        key: 'reply',
        label: t('reply'),
        icon: <RollbackOutlined />,
        disabled: !canReplyToThis,
        onClick: () => onAction('reply')
    }, {
        key: 'copy',
        label: t('copy'),
        icon: <CopyOutlined />,
        disabled: !message?.content,
        onClick: () => onAction('copy')
    }, {
        key: 'download',
        label: t('download'),
        icon: <DownloadOutlined />,
        disabled: !hasMedia,
        onClick: () => onAction('download')
    }, {
        key: 'details',
        label: t('details'),
        icon: <InfoCircleOutlined />,
        onClick: () => onAction('details')
    }];

    return (
        <div style={{ position: 'relative' }}>
            <Dropdown menu={{ items: menuItems }} trigger={['contextMenu']}>
                {children}
            </Dropdown>

            {(isHovered || contextMenuOpen) && !isMobile && (
                <div style={{ position: 'absolute', top: 5, right: 5, zIndex: 10 }}>
                    <Dropdown
                        menu={{ items: menuItems }}
                        trigger={['click']}
                        open={contextMenuOpen}
                        onOpenChange={(open) => {
                            setContextMenuOpen(open);
                        }}
                        placement="bottomRight"
                    >
                        <div style={{
                            cursor: 'pointer',
                            width: 24,
                            height: 24,
                            borderRadius: '50%',
                            background: 'rgba(0, 0, 0, 0.4)',
                            backdropFilter: 'blur(2px)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                        }}>
                            <DownOutlined style={{ color: '#fff', fontSize: 10 }} />
                        </div>
                    </Dropdown>
                </div>
            )}
        </div>
    );
};

export default MessageBubbleActions;
